import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=6d527572&scoped=true&"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMenu.vue?vue&type=style&index=0&id=6d527572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d527572",
  null
  
)

export default component.exports